const initialState = {
  PHHSTemplateEntriesData: [],
  PHHSTemplateEntryData: null,
  isLoadingTemplate: false,
  isModalConfirmDeleteTemplateOpen: false,
  PHHSConsultationEntriesData: [],
  PHHSConsultationEntryData: null,
  isLoadingConsultation: false,
  isModalConfirmDeleteConsultationOpen: false,
};

const PHHSReducer = (state = initialState, action) => {
  switch (action.type) {
    case "CLEAR_TEMPLATE_ENTRY_DATA":
      return {
        ...state,
        templatePHHSEntryData: null,
      };
    case "TOGGLE_MODAL_CONFIRM_DELETE_TEMPLATE":
      return {
        ...state,
        isModalConfirmDeleteTemplateOpen: !state.isModalConfirmDeleteTemplateOpen,
        PHHSTemplateEntryData: action.payload,
      };
    case "FETCH_TEMPLATE":
      return {
        ...state,
        PHHSTemplateEntriesData: action.payload,
      };
    case "SET_LOADING_TEMPLATE":
      return {
        ...state,
        isLoadingTemplate: action.payload,
      };
    case "FETCH_CONSULTATION":
      return {
        ...state,
        PHHSConsultationEntriesData: action.payload,
      };
    case "SET_LOADING_CONSULTATION":
      return {
        ...state,
        isLoadingConsultation: action.payload,
      };
    case "CLEAR_CONSULTATION_ENTRY_DATA":
      return {
        ...state,
        PHHSConsultationEntryData: null,
      };
    case "TOGGLE_MODAL_CONFIRM_DELETE_CONSULTATION":
      return {
        ...state,
        isModalConfirmDeleteConsultationOpen: !state.isModalConfirmDeleteConsultationOpen,
        PHHSConsultationEntryData: action.payload,
      };
    default:
      return state;
  }
};

export default PHHSReducer;
